import { FC } from "react";

interface ClosingCrossSVGProps {
    className?: string;
    onClick?: () => void;
}

const ClosingCrossSVG: FC<ClosingCrossSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            onClick={props.onClick}
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M0.593262 1L23 24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M23 1L0.593254 24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default ClosingCrossSVG;
